import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { useServicesStore } from '@/stores/services';
import type { Service, ServiceCategory } from '@/types';

export const useServiceDropdownOptions = () => {
  const { t } = useI18n();
  const { serviceCategories, servicePackages } = storeToRefs(
    useServicesStore(),
  );

  const packageOptions = computed(() =>
    servicePackages.value.map((servicePackage) => ({
      value: -servicePackage.id,
      label: servicePackage.name,
      labelExtra: filters.currency(servicePackage.price),
      badgeLabel: t('global.items.package', 1),
      groupValue: servicePackage.category?.id,
    })),
  );

  const serviceOptions = (services: Service[]) =>
    services
      .filter((service) => !service.deleted)
      .map((service) => ({
        value: service.id,
        label: service.name,
        labelExtra: filters.currency(service.price),
        groupValue: service.category.id,
      }));

  // Packages are listed before same-category services, so within a category
  // group they sort to the top.
  const dropdownOptions = (services: Service[]) => [
    ...packageOptions.value,
    ...serviceOptions(services),
  ];

  const dropdownGroups = computed(() =>
    serviceCategories.value.map((category: ServiceCategory) => ({
      value: category.id,
      label: category.name,
    })),
  );

  return { dropdownOptions, dropdownGroups };
};
